import React from "react";
import CRMWidget from '../../components/products/CRMWidget'; // Make sure this path is correct

// Extract THINKBIG INFOTECH paragraph
function extractThinkbigParagraph(content) {
  if (!content) return null;
  const match = content.match(/(<p><strong>THINKBIG INFOTECH[\s\S]*?<\/p>)/i);
  return match ? match[1] : null;
}

// Extract Product Overview section (stop before next <h4> or end)
function extractProductOverview(content) {
  if (!content) return null;
  const match = content.match(/(<h4>Product Overview<\/h4>[\s\S]*?)(?=<h4>|$)/i);
  return match ? match[1] : null;
}

const SideProduct = ({ content, slug }) => {
  const thinkbig = extractThinkbigParagraph(content);
  const ProductOverview = extractProductOverview(content);
  const showThinkbig = thinkbig && (!ProductOverview || !ProductOverview.includes(thinkbig));

  return (
    <aside className="product-side bg-light p-4 rounded-4 shadow" style={{ minHeight: 200 }}>
      {slug === 'crm' && <CRMWidget />} {/* Only show widget on CRM page */}
      {showThinkbig && (
        <div className="side-thinkbig mb-3" dangerouslySetInnerHTML={{ __html: thinkbig }} />
      )}
      {ProductOverview && (
        <div className="side-Product-Overview" style={{textAlign:'justify'}} dangerouslySetInnerHTML={{ __html: ProductOverview }} />
      )}
    </aside>
  );
};

export default SideProduct;
